import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const dynamicRewardsRootActionPath = 'core/DynamicRewardsTabContent/GET';

export const DYNAMIC_REWARDS_TAB_CONTENT_GET_SUCCESS = `${dynamicRewardsRootActionPath}_${SUCCESS_SUFFIX}`;
export const DYNAMIC_REWARDS_TAB_CONTENT_GET_FAILURE = `${dynamicRewardsRootActionPath}_${FAILURE_SUFFIX}`;
export const DYNAMIC_REWARDS_TAB_CONTENT_VIEW = `${dynamicRewardsRootActionPath}/VIEW`;
